import * as React from 'react';
import { Theme, StyleRules } from '@material-ui/core/styles';
import withStyles, { ClassNameMap } from '@material-ui/core/styles/withStyles';
import {
  Button,
  Grid,
  Paper,
  List,
  ListItem,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  LinearProgress,
} from '@material-ui/core';
import {
  CheckBox as CheckIcon,
  CheckBoxOutlineBlank as CheckBlankIcon,
  RadioButtonChecked as RadioButtonChecked,
  RadioButtonUncheckedOutlined as RadioButtonUncheckedOutlined,
} from '@material-ui/icons';
import { RiskJudge as RiskJudgeType } from '../modules/riskJudge';
import { UploadFile } from '../modules/upload';
// import { goJudgePage } from 'src/modules/pages';
import './RiskJudge.css';
import rickImage from '../img/risk.png';

interface Props {
  classes: ClassNameMap;
  files: (UploadFile | null)[];
  riskJudge: RiskJudgeType | null;
  clearRiskJudgeMessages: () => void;
  goUpalodRiskJudgePage: () => void;
  doRiskjudge: (id: number) => void;
}

interface State {
  modalIsOpen: boolean;
  tempdoc: string;
}

const style = (theme: Theme): StyleRules => ({
  compare: {
    marginTop: theme.spacing.unit * 3,
  },
  card: {
    border: 0,
    borderRadius: 3,
    boxShadow: '0px 1px 8px 0px rgba(0,0,0,0.2)',
    padding: '0 30px',
    margin: '5px',
    paddingTop: '10px',
  },
});

class RiskJudge extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      tempdoc: 'abcd',
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.backUploadPage = this.backUploadPage.bind(this);
  }

  static defaultProps: Partial<Props> = {    // Windowsが認識できないのでコメントアウト
    // accept: [
    //   'text/plain',
    //   'application/msword',
    //   'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    //   'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    //   'application/vnd.ms-word.document.macroEnabled.12',
    //   'application/vnd.ms-word.template.macroEnabled.12',
    // ],
  };

  // テンプレートダイアログ
  openModal = (tempDoc: string) => {
    this.setState({ modalIsOpen: true, tempdoc: tempDoc });
  }
  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  backUploadPage() {
    this.props.files.splice(0);
    this.props.files.push(null);
    this.props.goUpalodRiskJudgePage();
  }

  componentDidMount() {
    const { files, goUpalodRiskJudgePage, doRiskjudge } = this.props;
    const fileIds: number[] = [];
    files.forEach((file, i) => {
      if (file) {
        fileIds.push(file.id);
      }
    });
    if (fileIds.length > 0) {
      if (!this.props.riskJudge) {
        doRiskjudge(fileIds[0]);
      }
    } else {
      goUpalodRiskJudgePage();
    }
  }

  handleClose = () => {
    this.props.clearRiskJudgeMessages();
  }

  clearPtagStyle = () => {
    const ptagCollection = document.getElementsByName('LinkTags');
    for (const idx in ptagCollection) {
      const style = ptagCollection[idx].style;
      if (typeof style !== 'undefined') {
        style.backgroundColor = '';
      }
    }
  }

  changeBackgroundColor = (idx: string, color: string) => {
    const pTag = document.getElementById(idx) as HTMLInputElement;
    pTag.style.backgroundColor = color;
  }

  getIcon = (type: string) => {
    switch (type) {
      case 'checked':
        return <CheckIcon />;
      case 'unChecked':
        return <CheckBlankIcon />;
      case 'radioSelected':
        return <RadioButtonChecked />;
      case 'radioUnSelected':
        return <RadioButtonUncheckedOutlined />;
      default:
        return '';
    }
  }

  generateAtag = (id: string, linkName: string, color: string) => {
    return React.createElement(
      'a',
      {
        href: `#${id}`,
        onClick: () => {
          this.clearPtagStyle();
          this.changeBackgroundColor(id, color);
        },
      },
      linkName,
    );
  }

  setCardStyle = (logicColor: string) => {
    return {
      border: 0,
      borderRadius: 3,
      boxShadow: '0px 1px 8px 0px rgba(0,0,0,0.2)',
      padding: '0 30px',
      margin: '5px',
      paddingTop: '10px',
      backgroundColor: logicColor,
    };
  }

  render() {
    const {
      classes,
      riskJudge,
    } = this.props;
    return (
      <React.Fragment>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={this.backUploadPage}>
          戻る
        </Button>
      {riskJudge ? (
       <Grid container justify="center" spacing={16}>
        <Grid item xs={6}>
          <Typography variant="h5" gutterBottom>
            本文
          </Typography>
          <Paper elevation={3} style={{ maxHeight: '68vh', overflow: 'auto', fontSize: 15 }}>
              <div id="mainDoc" dangerouslySetInnerHTML={{ __html: riskJudge.mainDoc }}/>
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <table style={{ width: '100%' }} >
            <tr>
              <td>
                <Typography variant="h5">
                判定結果
                </Typography>
              </td>
              <td align="right">
                  <img src={rickImage} />
              </td>
            </tr>
          </table>
          <Paper elevation={3} style={{ maxHeight: '68vh', overflow: 'auto', fontSize: 15 }}>
            {riskJudge.logics.map((logic, i) => (
            <div style={this.setCardStyle(logic.logicColor)}>
              <Grid container direction="row" alignItems="center">
                <Grid item xs={9}>
                  <Typography variant="body1">
                    {logic.title}
                </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.openModal(logic.tempDoc)}
                  >
                    テンプレート
                  </Button>
                </Grid>
              </Grid>
              <List>
                {logic.judges.map((judge, j) => (
                  <ListItem>
                  <Grid container direction="row" alignItems="center">
                    <Grid item>
                      {this.getIcon(judge.judgeType)}
                    </Grid>
                    <Grid item>
                      {judge.name}
                    </Grid>
                    {judge.specificId.map((speicic, k) => (
                      <Grid item xs={12}>
                        {this.generateAtag(speicic.id, speicic.linkName, speicic.bgcolor)}
                      </Grid>
                    ))}
                  </Grid>
                </ListItem>
              ))}
              </List>
              <Grid container justify="flex-end" style={{ padding: '3px' }}>
                {logic.numberTitle}
              </Grid>
            </div>
            ))}
            <Dialog
              open={this.state.modalIsOpen}
              onClose={this.closeModal}
              fullWidth={true}
              maxWidth="md"
              aria-labelledby="apply-dialog-title"
            >
              <DialogTitle id="apply-dialog-title">テンプレート</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <p dangerouslySetInnerHTML={{ __html: this.state.tempdoc }} />
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.closeModal} color="primary">
                  閉じる
                </Button>
              </DialogActions>
            </Dialog>
            </Paper>
        </Grid>
      </Grid>
      ) :  (!riskJudge &&
        <div className={classes.root}>
          <LinearProgress className={classes.progress} />
        </div>
      )}
      </React.Fragment>
    );
  }
}

export default withStyles(style)(RiskJudge);



// WEBPACK FOOTER //
// ./src/components/RiskJudge.tsx